import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import { FormSelectionIcon } from '../../WorkviewManager/PaperProcessModel/FormSelectionList'
import ICONS from '../../Icons/Icons'
import { Spinner } from '../../Loaders/Loaders'
import * as api from '../../../requests'
import { SET_SELECTED_FORM } from '../Workview2Reducer'
import '../../WorkviewManager/WorkviewManager.scss'

const MiscFormSelectionList = ({ moduleId, icon }) => {
  const [forms, setForms] = useState([])
  const [loading, setLoading] = useState(false)
  const [formFilter, setFormFilter] = useState('')
  const dispatch = useDispatch()
  const selectedRow = useSelector((state) => state.workview2.selectedRow)

  useEffect(() => {
    setFormFilter('')
    setLoading(true)
    api.GET_MISC_PAPER_INITIAL_FILING_FORMS(
      moduleId,
      (data) => {
        setForms(data)
        setLoading(false)
      },
      () => {
        setLoading(false)
      }
    )
  }, [moduleId])

  const filteredForms = forms.filter(
    (f) => !formFilter || f.FormName.toLowerCase().includes(formFilter.toLowerCase())
  )

  return (
    <div>
      {loading && <Spinner className="page-loader" themeColor="neutral" />}
      {!loading && (
        <div className="filingSelectButtonWrapper" style={{ marginTop: '8px' }}>
          <SearchBox
            placeholder="Filter by form name"
            value={formFilter}
            onChange={(e) => setFormFilter(e)}
            showClearButton={false}
            showSearchButton={false}
          />
        </div>
      )}
      {!loading && forms.length === 0 && (
        <h1>No wizards configured for this module.</h1>
      )}
      {!loading && forms.length > 0 && filteredForms.length === 0 && (
        <div style={{ textAlign: 'center', width: '100%', marginTop: '7.5em', marginBottom: '7.5em' }}>
          <h1 style={{ padding: '15px', fontWeight: 'bold' }}>No forms match filtration criteria...</h1>
        </div>
      )}
      {!loading && filteredForms.length > 0 && (
        <div className="icon-wrapper">
          <div className="form-blocks paper-processed-wizard-item-wrapper">
            {filteredForms.map((item, i) => (
              <FormSelectionIcon
                key={i}
                formName={item.FormName}
                value={item.FormDefinitionId}
                icon={ICONS[icon]}
                selectedRow={selectedRow}
                processInitialFiling={() =>
                  dispatch({ type: SET_SELECTED_FORM, data: { formDefinitionID: item.FormDefinitionId } })
                }
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default MiscFormSelectionList
